import { Injectable } from '@angular/core';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SettingsService extends AppService {

  // Observable Settings (por ahora implementado solo para currency config)
  _settings = new BehaviorSubject<any>(null);
  observableSettings$ = this._settings.asObservable();


  // actualizamos data de observable Settings
  updateObservableSettings(data: any) {
    this._settings.next(data);
  }

  constructor(http: HttpClient) {
    super(http);
  }

  getSettings(community: Number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/settings`;
    return this.get(this.endpoint);
  }

  getSettingBySlug(communityId: number, slug: string, includeDebtTypes = false): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/configuration/community/${communityId}/${slug}?includeDebtTypes=${includeDebtTypes}`;
    return this.get(this.endpoint);
  }

  getCurrentPeriod(community: Number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/period/current`;
    return this.get(this.endpoint);
  }

  postUnitCommonExpense(community: number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/unit/common-expense`;
    return this.post(this.endpoint, data);
  }

  postLightCut(community: Number, form: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/configuration/community/${community}/suspense-light`;
    return this.post(this.endpoint, form);
  }

  putUpdatedDebtConfig(community: Number, form: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/updated-debt/congif`;
    return this.put(this.endpoint, form);
  }

  setCheckControlStatus(communityId: Number, status: boolean): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/set-status-control-check`;
    return this.put(this.endpoint, { status }, 'text');
  }

  getPropertyListCut(community: Number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/suspense-light/list`;
    return this.get(this.endpoint);
  }

  getCode(communityId: Number, fieldKey: string): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/code/${fieldKey}`;
    return this.get(this.endpoint);
  }

  setCode(communityId: Number, fieldKey: string, value: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/code/${fieldKey}`;
    return this.put(this.endpoint, { value: value }, 'text');
  }

  setCommonExpense(communityId: Number, data: any[]) {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/setting/common-expense`;
    return this.put(this.endpoint, data);
  }

  postCommunitySettingsDebtType(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/defaulters-parameters`;
    return this.post(this.endpoint, data, 'text');
  }
}




// WEBPACK FOOTER //
// ./src/app/services/settings.service.ts